import { SkeletonBox } from 'components/skeletonBox';
import styles from './BannerHero.module.scss';

export const BannerHeroSkeleton = () => (
   <SkeletonBox data-testid='banner-hero-skeleton' className={styles.skeleton} noPaddingTop noPaddingBottom />
);
